<template>

  <div>
      <div class='tabs' >
        <div style="padding:11px 10px;position: absolute;left: 0;background-color: #1C2B36;z-index: 10;" @click="styleLeft(1)">
          <i class="el-icon-d-arrow-left"></i>
        </div>
        <div  @click="clearTab" style="padding:12px 10px;position: absolute;left: 36px;background-color: #1C2B36;z-index: 10;" >
          <i class="el-icon-delete-solid" style="display:block;width:16px;margin:0 auto;"></i>
        </div>

          <div class="tabCon">
            <div class="flexCon" :style="'left:'+ left + 'px;'">
              <el-tag
                v-for="(item,index) in tabs"
                :key="item.router"
                v-if="!item.isTabHide"
                closable
                :disable-transitions="false"
                @click="onTabClick(item)"
                @close="onRemoveTab(item)"
                style="border: none;max-width:200px;width: auto;"
                :style="index==0?'border-bottom:4px solid #00B7EE':''"
                >
                <div style="float:left;overflow: hidden;max-width:120px!important;">
                  {{item.params&&item.params.title?(item.params.title.length>5?item.params.title.substring(0,5)+'...':item.params.title):item.show_name}}
                </div>

              </el-tag>
            </div>
          </div>

          <div style="padding:11px 10px;position: absolute;right: 0;background-color: #1C2B36;" @click="styleLeft(-1)">
            <i class="el-icon-d-arrow-right"></i>
          </div>
      </div>
  </div>

</template>

<script>
  export default {
    name: 'sls-tabs',
    data() {
      return {
        strong: '',
        currentItem:{},
        left:0,
        leftIndex:0
      }
    },
    computed: {
      tabs () {
        return this.$store.state.tabs.tabs
      }
    },
    mounted() {
         console.log('this.$store.state.tabs.tabs', this.$store.state.tabs.tabs);
    //      console.log('this.$store.state.tabs.pathList', this.$store.state.tabs.pathList);
    //      console.log('this.tabs_cur', this.tabs_cur);
    },
    created() {
      const self = this;
      self.currentItem = self.tabs[0];

    },
    methods: {

      styleLeft(type){
        const self = this;
        var tabBox= document.querySelector(".tabCon");
        var flexBox= document.querySelector(".flexCon");
        var tabW = tabBox.offsetWidth;
        var flexW = flexBox.offsetWidth;

        if(130*(self.leftIndex+type)>0 || ((flexW+self.left)<tabW&&type==-1)){
          console.log('原始',self.left,self.leftIndex)
          return;
        }
        self.leftIndex += type;
        self.left = 130*self.leftIndex;
        console.log(flexBox.offsetWidth,tabBox.offsetWidth,self.left,self.leftIndex,type)
      },

      getPageText (name) {
        return name.replace('编辑', this.$route.query.id ? '修改' : '添加')
      },

      clearTab(){
        const self = this;
        self.$store.commit('CLEAR_TABS', {
          currentItem:self.tabs[0],
        });
      },

     onTabClick(item) {
       const self = this;
       if (self.$router.history.current.fullPath != item.router) {
         self.$router.push({
           path:item.router,
           name:item.name,
           params:item.params,
           query:item.query,
         });
       };

     },

      onRemoveTab(item) {
        const self = this;

        self.$store.commit('REMOVE_TABS', {
          fullPath:item.router,
        });

        if(self.tabs.length==0){
          self.$router.push('/login');
        }else{
          self.$router.push({
            path:self.tabs[0].router,
          });
        }
      }
    },

    watch: {
      $route (to, from) {
        this.strong = this.getPageText(to.name)
      }
    }
  }
</script>

<style >
  .tabs{
    padding: 0 36px 0 72px;
    display:flex;
    color: #fff;
    background-color: #1C2B36;
    font-size: 16px;
    position: relative;
  }

  .clear{
    padding: 0 16px;
    height: 42px;
    box-sizing: border-box;
    line-height: 42px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    color: #8391a5;
    position: relative;
    border:1px solid #d1dbe5;
  }


  .el-tabs__item.is-active {

  }

  .tabs .el-tag{width: 130px;height: 40px;line-height: 40px;font-size: 14px;position: relative;background-color: initial;color: #fff;cursor: pointer;border-radius: 0;}
  .tabs .el-tag::before{width: 1px;height: 22px;background-color: #59646C;position: absolute;left: 0;top: 50%;margin-top: -11px;content: '';}
  .el-tag .el-tag__close{color: #fff;font-size: 16px;}


  /* 竖屏 */
  @media only screen and (max-width: 1200px) {
  	.tabs{height: 30px!important;overflow: hidden;}
  	.tabs .el-tag{font-size: 12px;height: 30px;line-height: 30px;}
  	.icon10,.icon12{padding: 8px 10px;}
  	.icon11{padding: 7px 10px;}
  }

</style>
<style scoped>
 .tabCon{width: 100%;position: relative;background-color: #1C2B36;height: 40px;}
 .flexCon{display: flex;position: absolute;background-color: #1C2B36;transition: all 0.3s;}
 .tabs .el-tag{flex-shrink: 0;}
</style>



// WEBPACK FOOTER //
// src/layout/tabs.vue